import { apiTypes } from 'shared/consts/handbooksApiTypes';

const config = {
  schema: '',
  table: 'ble_settings',
  title: 'Референсные значения RSSI',
  apiType: apiTypes.ALT_NAV_API,
  elemsOnPage: 100,
  connections: {
    bledevicestype: {
      apiType: apiTypes.ALT_NAV_API,
      table: 'ble_devices_type',
      fields: ['name_type'],
      format: (elem: any) => elem['name_type'],
      index: 'id',
      autocomplete: true,
    },
  },
  fields: [
    {
      name: 'id',
      title: 'ID записи',
      index: true,
      type: 'number',
      width: '120px',
      disableFilter: true
    },
    {
      name: 'device_type_id',
      title: 'Тип',
      type: 'number',
      width: '200px',
      required: true,
      connection: 'bledevicestype',
    },
    {
      name: 'ref_rssi_1',
      title: 'Референсный RSSI на расстоянии 1 м',
      type: 'number',
      canBeNegative: true,
      required: true,
    },
    {
      name: 'ref_rssi_5',
      title: 'Референсный RSSI на расстоянии 5 м',
      type: 'number',
      canBeNegative: true,
      required: true,
    },
    {
      name: 'ref_rssi_10',
      title: 'Референсный RSSI на расстоянии 10 м',
      type: 'number',
      canBeNegative: true,
      required: true,
    },
    {
      name: 'ref_rssi_15',
      title: 'Референсный RSSI на расстоянии 15 м',
      type: 'number',
      canBeNegative: true,
      required: true,
    },
    {
      name: 'ref_rssi_20',
      title: 'Референсный RSSI на расстоянии 20 м',
      type: 'number',
      canBeNegative: true,
      required: true,
    },
  ],
  newTemplate: {
    device_type_id: null,
    ref_rssi_1: null,
    ref_rssi_5: null,
    ref_rssi_10: null,
    ref_rssi_15: null,
    ref_rssi_20: null,
  },
  makeIdOnInsert: true,
  defaultSort: {
    field: 'id',
    direction: 'desc',
  },
  import: {
    header: [
      {
        title: 'id',
        field: 'id'
      },
      {
        title: 'device_type_id',
        field: 'device_type_id'
      },
      {
        title: 'ref_rssi_1',
        field: 'ref_rssi_1'
      },
      {
        title: 'ref_rssi_5',
        field: 'ref_rssi_5'
      },
      {
        title: 'ref_rssi_10',
        field: 'ref_rssi_10'
      },
      {
        title: 'ref_rssi_15',
        field: 'ref_rssi_15'
      },
      {
        title: 'ref_rssi_20',
        field: 'ref_rssi_20'
      },
    ],
    example: `1;1;1000;1000;1000;1000;1000`
  }
};

export default config;